import { render, staticRenderFns } from "./searchPatente.vue?vue&type=template&id=05b691d6&scoped=true&"
import script from "./searchPatente.vue?vue&type=script&lang=ts&"
export * from "./searchPatente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b691d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('05b691d6', component.options)
    } else {
      api.reload('05b691d6', component.options)
    }
    module.hot.accept("./searchPatente.vue?vue&type=template&id=05b691d6&scoped=true&", function () {
      api.rerender('05b691d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlDispositivos/searchPatente.vue"
export default component.exports